module.exports = __webpack_public_path__ + "img/gywm.0ca3ab5e.svg";